import api, { refreshTokenApi, multipartApi } from './axios';

// dashboard api

export const lastDay = (time) =>api(`users?&createdAt=${time}`, 'GET')

// user apis
export const userLogin = (data) => api('auth/login', 'POST', data);
export const deleteUsr = (id) => api(`auth/delete-account/${id}`, 'DELETE');
export const getUsr = (id) => api(`users/${id}`, 'GET');
export const userLogout = (data) => api(`auth/logout`, 'POST', data);
export const getUsers = (limit = 10, offset = 1, firstname = '', status = '', role = 'user') => api(`users?limit=${limit}&page=${offset}&role=${role}&sortBy=asc&status=${status}&first_name=${firstname}`, 'GET');
export const refreshTokens = (data) => refreshTokenApi(`auth/refresh-tokens`, 'POST', data);
export const resetPassword = (token, data) => api(`auth/reset-password?token=${token}`, 'POST', data);
export const getUsersWithFilter = (query) => api(query, 'GET');
export const updateUser = (data, id) => api(`users/${id}`, 'PATCH', data);
export const userProfileCalculation = (id) => api(`users/get-profile-percentage/${id}`);
export const getUserStatistics = (groupingUnit, startDate, endDate) =>
    api(`statistics?unit=${groupingUnit}&startDate=${startDate}&endDate=${endDate}`, 'GET');
export const getUserLoginStatistics = (startDate, endDate) =>
    api(`statistics/login-statistics?startDate=${startDate}&endDate=${endDate}`, 'GET');

// university management
export const createUniverSity = (data) => api('universities', 'POST', data)
export const viewUniversity = (limit = 10, offset = 1, firstname = '',) => api(`universities?limit=${limit}&page=${offset}&name=${firstname}&custom=true&sortBy=name:asc`, 'GET')
export const deleteUniversity = (id) => api(`universities/${id}`, 'DELETE');
export const updateUniversity = (data, id) => api(`universities/${id}`, 'PATCH', data);

// notification management
export const createNotification = (data) => api('notifications', 'POST', data)
export const viewNotification = (limit = 10, offset = 1, firstname = '',) => api(`notifications?limit=${limit}&page=${offset}&title=${firstname}&custom=true&sortBy=createdAt:desc`, 'GET')
export const deleteNotification = (id) => api(`notifications/${id}`, 'DELETE');
export const updateNotification = (data, id) => api(`notifications/${id}`, 'PATCH', data);

// skill & course management
export const createCourse = (data) => api('cources', 'POST', data)
export const createSpeciality = (data) => api('commonRoutes/generateSpeciality', 'POST', data)
export const viewCourse = (limit = 10, offset = 1, firstname = '',) => api(`cources?limit=${limit}&page=${offset}&name=${firstname}&custom=true&sortBy=name:asc`, 'GET')
export const viewSpeciality = (limit = 10000, offset = 1, firstname = '',) => api(`commonRoutes/getSpeciality?limit=${limit}&page=${offset}&name=${firstname}&custom=true&sortBy=name:asc`, 'GET')
export const deleteCourse = (id) => api(`cources/${id}`, 'DELETE');
export const deleteSpeciality = (id) => api(`commonRoutes/deleteSpeciality/${id}`, 'DELETE');
export const updateCourse = (data, id) => api(`cources/${id}`, 'PATCH', data)
export const updateSpeciality = (data, id) => api(`commonRoutes/updateSpeciality/${id}`, 'PATCH', data)

// industry management 
export const createIndustry = (data) => api('industries', 'POST', data)
export const viewIndustry = (limit = 10000, offset = 1, name = '',) => api(`industries?limit=${limit}&page=${offset}&name=${name}&custom=true&sortBy=name:asc`, 'GET')
export const deleteIndustry = (id) => api(`industries/${id}`, 'DELETE');
export const updateIndustry = (data, id) => api(`industries/${id}`, 'PATCH', data)

// question management

export const createQuestion = (data) => api('s2Questions', 'POST', data)
export const viewQuestion = (limit = 10, offset = 1, firstname = '',) => api(`s2Questions?limit=${limit}&page=${offset}&question=${firstname}&custom=true`, 'GET')
export const deleteQuestion = (id) => api(`s2Questions/${id}`, 'DELETE');
export const updateQuestion = (data, id) => api(`s2Questions/${id}`, 'PATCH', data)

// company management
export const organizationsRegister = (data) => api('organizations/register', 'POST', data);
export const organizationsLogin = (data) => api('organizations/login', 'POST', data);

// common APIS
export const getSpeciality = (speciality = '') => api(`commonRoutes/getSpeciality?limit=20&name=${speciality}&custom=true`, 'GET');

// country-city-state management
export const countryData = () => api('countries', 'GET');
export const addCountry = (data) => api('countries', 'POST', data);
export const getCountries = (name = '', offset = 1 ) => api(`countries?sort=name:asc&limit=10000&page=${offset}&name=${name}&custom=true`, 'GET');
export const getStateList = (name = '' , offset = 1) => api(`states?name=${name}&page=${offset}&limit=10000&custom=true`, 'GET');
export const getCities = (name = '',countrycode = '', statecode = '' , offset = 1) => api(`cities?name=${name}&country_code=${countrycode}&page=${offset}&state_code=${statecode}&limit=20&custom=true`, 'GET');
export const deleteCountry = (id) => api(`countries/${id}`, 'DELETE');
export const updateCountry = (data, id) => api(`countries/${id}`, 'PATCH', data)

// image upload API
export const imageUpload = (data) => multipartApi(`filemanagement/uploadimage`, 'POST', data)
export const videoUpload = (data) => multipartApi('filemanagementLargeFiles/uploadvideo', 'POST', data)

// state 
export const createState = (data) => api('states', 'POST', data);
export const getStateData = (name = '', limit = 10, offset = 1) => api(`states?name=${name}&limit${limit}&page=${offset}&custom=true&sortBy=name:asc`, 'GET');
export const deleteState = (id) => api(`states/${id}`, 'DELETE')
export const updateState = (data,id) =>api(`states/${id}`,'PATCH',data)

// city
export const createCity =(data)=>api('cities','POST',data)
export const getCityData = (name = '' ,limit = 10, offset = 1) => api(`cities?limit=${limit}&page=${offset}&name=${name}&custom=true&sortBy=name:asc`, 'GET')
export const deleteCity =(id)=>api(`cities/${id}`, 'DELETE')
export const updateCity =(data,id) =>api(`cities/${id}`,'PATCH',data)

// language Management
export const createLanguage =(data)=>api('language','POST',data)
export const getlanguage = (limit = 10, offset = 1, name = '',) => api(`language?limit=${limit}&page=${offset}&name=${name}&custom=true&sortBy=name:asc`, 'GET')
export const deleteLanguage = (id)=>api(`language/${id}`, 'DELETE')
export const updateLanguage = (data,id) => api(`language/${id}`,'PATCH',data)

// Events Management
export const createEvents =(data)=>api('events','POST',data)
export const getEvents = (limit = 10000, offset = 1, name = '',) => api(`events?limit=${limit}&page=${offset}&code=${name}&custom=true&sortBy=createdAt:desc`, 'GET')
export const deleteEvents = (id)=>api(`events/${id}`, 'DELETE')
export const updateEvents = (data,id) => api(`events/${id}`,'PATCH',data)

// Jobs Management
export const createJobs =(data)=>api('jobs','POST',data)
export const getJobs = (limit = 10, offset = 1, name = '',) => api(`jobs/all?limit=${limit}&page=${offset}&code=${name}&custom=true&sortBy=code:asc`, 'GET')
export const deleteJobs = (id)=>api(`jobs/${id}`, 'DELETE')
export const updateJobs = (data,id) => api(`jobs/admin/${id}`,'PATCH',data)

// categories Management
export const createCategories =(data)=>api('categories','POST',data)
export const getCategories = (limit = 10, offset = 1, name = '',) => api(`categories?limit=${limit}&page=${offset}&name=${name}&custom=true&sortBy=createdAt:desc`, 'GET')
export const deleteCategories = (id)=>api(`categories/${id}`, 'DELETE')
export const updateCategories = (data,id) => api(`categories/${id}`,'PATCH',data)

// categories Management
export const createIntrests =(data)=>api('intrests','POST',data)
export const getIntrests = (limit = 10, offset = 1, name = '',) => api(`intrests?limit=${limit}&page=${offset}&name=${name}&custom=true&sortBy=createdAt:desc`, 'GET')
export const deleteIntrests = (id)=>api(`intrests/${id}`, 'DELETE')
export const updateIntrests = (data,id) => api(`intrests/${id}`,'PATCH',data)

// Prompts Management (admin monitoring: who is posting + matching/interest results)
export const getAdminPrompts = (limit = 10, offset = 1, title = '') =>
    api(`prompts/admin?limit=${limit}&page=${offset}&title=${title}&sortBy=updatedAt:desc`, 'GET');
export const deletePrompt = (id) => api(`prompts/${id}`, 'DELETE');
export const getPromptGroupMembers = (id, limit = 200, offset = 1) =>
    api(`prompts/${id}/group-members?limit=${limit}&page=${offset}`, 'GET');

// Feedback Management
export const createFeedback =(data)=>api('feedbacks','POST',data)
export const getFeedback = (limit = 10, offset = 1,status) => api(`feedbacks?limit=${limit}&page=${offset}&status=${status}&custom=true&sortBy=createdAt:desc`, 'GET')
export const deleteFeedback = (id)=>api(`feedbacks/${id}`, 'DELETE')
export const updateFeedback = (data,id) => api(`feedbacks/${id}`,'PATCH',data)
export const sendFeedback = (data,id) => api(`feedbacks/send-reply/${id}`,'POST',data)